import { DateTime, Duration } from 'luxon';

export const dateFromOdoo = (date: string): DateTime => DateTime.fromSQL(date, { zone: 'utc' }).toLocal();

export const dateFromOdooToFrench = (date: string): string => dateFromOdoo(date).toLocaleString(DateTime.DATE_SHORT);

export const dateFromOdooToFrenchMedium = (date: string): string =>
    dateFromOdoo(date).toLocaleString(DateTime.DATE_MED);

export const dateTimeToOdooDatetime = (date: DateTime | null) =>
    date ? date.toUTC().toFormat('yyyy-MM-dd HH:mm:ss') : false;

export const nowToOdooDatetime = () => dateTimeToOdooDatetime(DateTime.now());

export const isoToOdooDatetime = (iso: string) => dateTimeToOdooDatetime(DateTime.fromISO(iso));

export const floatToTime = (hours: number, format?: string) =>
    Duration.fromObject({ hours }).toFormat(format || "hh'h'mm");

export const hoursToDurationFormat = (hours: number, format?: string) =>
    hoursToDuration(hours).toFormat(format || "hh'h'mm");

export const hoursToDuration = (hours: number) => {
    // Prevent bug with luxon when 1h05 is converted to 1h4m59s instead of 1h5m and 1h55 becomes 1h54m59s
    let minutes = Math.round(Duration.fromObject({ hours }).as('minutes'));

    return Duration.fromObject({ minutes });
};

export const stringTimeToFloat = (time: string | undefined | null) => {
    if (!time) return 0;

    return Duration.fromISOTime(time).as('hours');
};
